import React from 'react';
import styles from './AgencyReportsHeaderFilter.module.scss';
import { SFChip, SFDropdownField, SFDropdownFieldOption } from 'sfui';
import { ReportPreFilter } from '../../../../../Models';

const isValueSelected = (
  selected: ReportPreFilter,
  chipLabel: string
): boolean => {
  switch (selected) {
    case 'all':
      return chipLabel === 'ALL';
    case 'cad_rms':
      return chipLabel === 'CAD/RMS';
    case 'contacts_reportable':
      return chipLabel === 'Contacts: Reportable to the state';
    case 'contacts_completed':
      return chipLabel === 'Contacts: Completed';
    case 'contacts_missing_information':
      return chipLabel === 'Contacts: Missing information';
  }
};

export interface AgencyReportsHeaderFilterProps {
  selected?: ReportPreFilter;
  isLoading?: boolean;
  onFilterChange: (selected: ReportPreFilter) => void;
}

export const AgencyReportsHeaderFilter = ({
  selected = 'all',
  isLoading = false,
  onFilterChange
}: AgencyReportsHeaderFilterProps): React.ReactElement<AgencyReportsHeaderFilterProps> => {
  const HEADER_FILTER_OPTIONS: SFDropdownFieldOption[] = React.useMemo(
    () => [
      {
        label: 'ALL',
        onClick: () => onFilterChange('all'),
        disabled: isLoading && selected !== 'all'
      },

      {
        label: 'CAD/RMS',
        onClick: () => onFilterChange('cad_rms'),
        disabled: isLoading && selected !== 'cad_rms'
      },
      {
        label: 'Contacts: Reportable to the state',
        onClick: () => onFilterChange('contacts_reportable'),
        disabled: isLoading && selected !== 'contacts_reportable'
      },
      {
        label: 'Contacts: Completed',
        onClick: () => onFilterChange('contacts_completed'),
        disabled: isLoading && selected !== 'contacts_completed'
      },
      {
        label: 'Contacts: Missing information',
        onClick: () => onFilterChange('contacts_missing_information'),
        disabled: isLoading && selected !== 'contacts_missing_information'
      }
    ],
    [onFilterChange, isLoading, selected]
  );

  return (
    <div className={styles.agencyReportsHeaderFilter}>
      <div className={styles.selectWrapper}>
        <SFDropdownField
          options={HEADER_FILTER_OPTIONS}
          sfColor="blue"
          variant="contained"
          fullWidth={true}
          popperZIndex={2000}
        />
      </div>
      <div className={styles.chipsWrapper}>
        {HEADER_FILTER_OPTIONS.map((option: SFDropdownFieldOption) => {
          return (
            <SFChip
              className={styles.chip}
              key={option.label}
              label={option.label}
              sfColor="primary"
              size="small"
              disabled={option.disabled}
              variant={
                isValueSelected(selected, option.label) ? 'default' : 'outlined'
              }
              onClick={option.onClick}
            />
          );
        })}
      </div>
    </div>
  );
};
